/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for the MonitoredDomain model.
 * @export
 * @interface PatchedMonitoredDomain
 */
export interface PatchedMonitoredDomain {
    /**
     * 
     * @type {number}
     * @memberof PatchedMonitoredDomain
     */
    readonly id?: number;
    /**
     * The domain name to monitor
     * @type {string}
     * @memberof PatchedMonitoredDomain
     */
    domainName?: string;
    /**
     * Comma-separated tags for categorizing domains
     * @type {string}
     * @memberof PatchedMonitoredDomain
     */
    tags?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedMonitoredDomain
     */
    readonly tagList?: string;
    /**
     * Whether monitoring is active for this domain
     * @type {boolean}
     * @memberof PatchedMonitoredDomain
     */
    isActive?: boolean;
    /**
     * Additional information about this monitored domain
     * @type {string}
     * @memberof PatchedMonitoredDomain
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PatchedMonitoredDomain
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedMonitoredDomain
     */
    readonly updatedAt?: Date;
}

/**
 * Check if a given object implements the PatchedMonitoredDomain interface.
 */
export function instanceOfPatchedMonitoredDomain(value: object): value is PatchedMonitoredDomain {
    return true;
}

export function PatchedMonitoredDomainFromJSON(json: any): PatchedMonitoredDomain {
    return PatchedMonitoredDomainFromJSONTyped(json, false);
}

export function PatchedMonitoredDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedMonitoredDomain {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'domainName': json['domain_name'] == null ? undefined : json['domain_name'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'tagList': json['tag_list'] == null ? undefined : json['tag_list'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedMonitoredDomainToJSON(json: any): PatchedMonitoredDomain {
      return PatchedMonitoredDomainToJSONTyped(json, false);
  }

  export function PatchedMonitoredDomainToJSONTyped(value?: Omit<PatchedMonitoredDomain, 'id'|'tag_list'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain_name': value['domainName'],
        'tags': value['tags'],
        'is_active': value['isActive'],
        'description': value['description'],
    };
}

